import * as React from 'react'
import { MuiTextFieldFormik } from '@user/components/Formik'
import { Field } from 'formik'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

const inputProps = {
  maxLength: 255,
  'data-test-id': 'activity-form-description-field-input',
}

type Props = {
  mt?: number
}

export function DescriptionField(props: Props) {
  const { mt = 0 } = props
  return (
    <Stack>
      <Typography variant="body1" mt={mt} fontSize={16}>
        Add Description
      </Typography>
      <Field
        fullWidth
        size="small"
        name="description"
        component={MuiTextFieldFormik}
        inputProps={inputProps}
        data-test-id={`activity-form-description-field`}
      />
    </Stack>
  )
}
